import { jsPDF } from "jspdf";
import { saveTurnoPDFService } from "modules/came/services/userCameService";

export const generarPDFCierreTurno = async (data) => {
  try {
    const { formData, responseData } = data;

    // Validar datos requeridos
    if (!formData || !responseData) {
      throw new Error("Datos del formulario o respuesta del backend no disponibles");
    }

    // Extraer datos del sistema
    const sistemaData = responseData?.data || responseData || {};
    const balanceData = sistemaData.balance?.[0] || sistemaData.balance || {};
    const transData = sistemaData.trans || {};

    // Datos del formulario
    const efectivoInicial = Number(formData?.efectivoInicial || 0);
    const recaudoEfectivoReportado = Number(formData?.recaudoEfectivo || 0);
    const usuario = formData?.usuarioNombre || sistemaData.user_kme || "Explotador";
    const estacion = formData?.numeroCaja || balanceData.NumeroCaja || "04";

    // Datos del sistema
    const efectivoSistema = Number(transData.valorE || 0);
    const tarjetaSistema = Number(transData.valorT || 0);
    const valorTotalSistema = efectivoSistema + tarjetaSistema;
    const diferenciaEfectivo = recaudoEfectivoReportado - efectivoSistema;

    // Crear documento PDF
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    let yPosition = 12;

    // Funciones auxiliares
    const formatCurrency = (value) => {
      if (value === null || value === undefined || isNaN(value)) {
        return "$ 0";
      }
      const numValue = Number(value);
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(numValue);
    };

    const formatDateWithColombiaTime = (dateString) => {
      if (!dateString || dateString === "N/A") return "No disponible";
      try {
        const fecha = new Date(dateString);
        if (isNaN(fecha.getTime())) return "Fecha inválida";
        const fechaColombia = new Date(fecha.getTime() + 5 * 60 * 60 * 1000);
        return (
          fechaColombia.toLocaleDateString("es-CO") +
          " " +
          fechaColombia.toLocaleTimeString("es-CO", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        );
      } catch (error) {
        console.warn("Error formateando fecha con ajuste Colombia:", error);
        return "Fecha inválida";
      }
    };

    const formatDateRegular = (dateString) => {
      if (!dateString || dateString === "N/A") return "No disponible";
      try {
        const fecha = new Date(dateString);
        if (isNaN(fecha.getTime())) return "Fecha inválida";
        return (
          fecha.toLocaleDateString("es-CO") +
          " " +
          fecha.toLocaleTimeString("es-CO", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        );
      } catch (error) {
        console.warn("Error formateando fecha regular:", error);
        return "Fecha inválida";
      }
    };

    const calcularDuracion = () => {
      const inicio = balanceData.FHInicio || formData?.inicioTurno;
      const fin = balanceData.FHFin || formData?.fechaCierre || formData?.finTurno;

      if (!inicio || !fin || inicio === "N/A" || fin === "N/A") {
        return "N/A";
      }

      try {
        const fechaInicio = new Date(inicio);
        const fechaFin = new Date(fin);

        if (isNaN(fechaInicio.getTime()) || isNaN(fechaFin.getTime())) {
          return "N/A";
        }

        const diferenciaMs = fechaFin - fechaInicio;
        const horas = Math.floor(diferenciaMs / (1000 * 60 * 60));
        const minutos = Math.floor((diferenciaMs % (1000 * 60 * 60)) / (1000 * 60));
        const segundos = Math.floor((diferenciaMs % (1000 * 60)) / 1000);

        if (horas > 0) {
          return `${horas}h ${minutos}m ${segundos}s`;
        } else if (minutos > 0) {
          return `${minutos}m ${segundos}s`;
        } else {
          return `${segundos}s`;
        }
      } catch {
        return "N/A";
      }
    };

    // ============================================
    // ENCABEZADO
    // ============================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(25, 118, 210);
    doc.text("CENTRO COMERCIAL ISERRA 100", pageWidth / 2, yPosition, { align: "center" });
    yPosition += 4;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(128, 128, 128);
    doc.text("NIT: 830.019.348-2 | SISTEMA: LINCE V7.0", pageWidth / 2, yPosition, {
      align: "center",
    });
    yPosition += 3;

    doc.text(`#ID MAQUINA: ISERRA 100 | ESTACIÓN: Caja ${estacion}`, pageWidth / 2, yPosition, {
      align: "center",
    });
    yPosition += 3;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text("COMPROBANTE DE CIERRE DE TURNO", pageWidth / 2, yPosition, { align: "center" });
    yPosition += 8;

    doc.setDrawColor(200, 200, 200);
    doc.line(15, yPosition, pageWidth - 15, yPosition);
    yPosition += 8;

    // ============================================
    // INFORMACIÓN GENERAL
    // ============================================

    const now = new Date();
    const fechaGeneracion = formatDateRegular(now.toISOString());

    const infoData = [
      { label: "Fecha Generación:", value: fechaGeneracion },
      { label: "Usuario Operador:", value: usuario },
      { label: "Estación:", value: `Caja ${estacion}` },
    ];

    infoData.forEach((item, index) => {
      doc.setFont("helvetica", "normal");
      doc.setTextColor(80, 80, 80);
      doc.text(item.label, 20, yPosition + index * 6);

      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      const textWidth = doc.getTextWidth(item.value);
      doc.text(item.value, pageWidth - 20 - textWidth, yPosition + index * 6);
    });

    yPosition += infoData.length * 6 + 6;

    doc.setDrawColor(200, 200, 200);
    doc.line(15, yPosition, pageWidth - 15, yPosition);
    yPosition += 8;

    // ============================================
    // HORARIOS DEL TURNO
    // ============================================

    const inicioTurno = formatDateWithColombiaTime(balanceData.FHInicio || formData?.inicioTurno);
    const finTurno = formatDateWithColombiaTime(
      balanceData.FHFin || formData?.fechaCierre || formData?.finTurno
    );
    const duracion = calcularDuracion();

    const horariosData = [
      { label: "Inicio de Turno:", value: inicioTurno },
      { label: "Fin de Turno:", value: finTurno },
      { label: "Duración:", value: duracion },
    ];

    horariosData.forEach((item, index) => {
      doc.setFont("helvetica", "normal");
      doc.setTextColor(80, 80, 80);
      doc.text(item.label, 20, yPosition + index * 6);

      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      const textWidth = doc.getTextWidth(item.value);
      doc.text(item.value, pageWidth - 20 - textWidth, yPosition + index * 6);
    });

    yPosition += horariosData.length * 6 + 8;

    doc.setDrawColor(200, 200, 200);
    doc.line(15, yPosition, pageWidth - 15, yPosition);
    yPosition += 8;

    // ============================================
    // RESUMEN FINANCIERO
    // ============================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(25, 118, 210);
    doc.text("RESUMEN FINANCIERO", 20, yPosition);
    yPosition += 8;

    // EFECTIVO
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(0, 128, 0);
    doc.text("EFECTIVO", 20, yPosition);
    yPosition += 6;

    const efectivoData = [
      { label: "Efectivo Inicial:", value: formatCurrency(efectivoInicial) },
      { label: "Recaudo Efectivo Reportado:", value: formatCurrency(recaudoEfectivoReportado) },
      { label: "Efectivo Sistema:", value: formatCurrency(efectivoSistema) },
    ];

    efectivoData.forEach((item, index) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(80, 80, 80);
      doc.text(item.label, 25, yPosition + index * 5.5);

      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      const textWidth = doc.getTextWidth(item.value);
      doc.text(item.value, pageWidth - 20 - textWidth, yPosition + index * 5.5);
    });

    yPosition += efectivoData.length * 5.5 + 4;

    // Diferencia
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text("Diferencia:", 25, yPosition);

    doc.setFont("helvetica", "bold");
    doc.setTextColor(diferenciaEfectivo >= 0 ? 0 : 255, diferenciaEfectivo >= 0 ? 128 : 0, 0);
    const diferenciaText = formatCurrency(diferenciaEfectivo);
    const diferenciaWidth = doc.getTextWidth(diferenciaText);
    doc.text(diferenciaText, pageWidth - 20 - diferenciaWidth, yPosition);

    yPosition += 8;

    // TARJETA
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 150);
    doc.text("TARJETA", 20, yPosition);
    yPosition += 6;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text("Recaudo Tarjeta Sistema:", 25, yPosition);

    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    const tarjetaText = formatCurrency(tarjetaSistema);
    const tarjetaWidth = doc.getTextWidth(tarjetaText);
    doc.text(tarjetaText, pageWidth - 20 - tarjetaWidth, yPosition);

    yPosition += 8;

    // TOTAL SISTEMA
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(25, 118, 210);
    doc.text("TOTAL SISTEMA", 20, yPosition);
    yPosition += 6;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text("Efectivo + Tarjeta:", 25, yPosition);

    doc.setFont("helvetica", "bold");
    doc.setTextColor(25, 118, 210);
    const totalText = formatCurrency(valorTotalSistema);
    const totalWidth = doc.getTextWidth(totalText);
    doc.text(totalText, pageWidth - 20 - totalWidth, yPosition);

    yPosition += 8;

    doc.setDrawColor(200, 200, 200);
    doc.line(15, yPosition, pageWidth - 15, yPosition);
    yPosition += 15;

    // ============================================
    // FIRMAS Y SELLOS
    // ============================================

    doc.setDrawColor(150, 150, 150);
    doc.setLineDash([2, 2]);
    doc.line(15, yPosition, pageWidth - 15, yPosition);
    doc.setLineDash([]);
    yPosition += 12;

    const firmaLeft = 30;
    const firmaRight = pageWidth - 80;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("_________________________", firmaLeft, yPosition);
    doc.text("Firma Responsable", firmaLeft + 10, yPosition + 6);

    doc.text("_________________________", firmaRight, yPosition);
    doc.text("Sello y Fecha", firmaRight + 12, yPosition + 6);

    yPosition += 20;

    // ============================================
    // PIE DE PÁGINA
    // ============================================

    doc.setFont("helvetica", "italic");
    doc.setFontSize(7);
    doc.setTextColor(128, 128, 128);
    doc.text("LINCE V7.0 | Este documento es un comprobante oficial", pageWidth / 2, yPosition, {
      align: "center",
    });
    yPosition += 3;
    doc.text(
      "Generado automáticamente por el sistema de cierre de turnos",
      pageWidth / 2,
      yPosition,
      {
        align: "center",
      }
    );

    // ============================================
    // GUARDAR PDF
    // ============================================

    const pdfBlob = doc.output("blob");
    const fileName = `cierre_turno_caja${estacion}_${Date.now()}.pdf`;
    const pdfFile = new File([pdfBlob], fileName, { type: "application/pdf" });

    doc.save(fileName);

    const pdfUrl = URL.createObjectURL(pdfBlob);

    const idSave = responseData?.idSave || sistemaData?.idSave || responseData?.data?.idSave;

    if (idSave && idSave !== "N/A") {
      try {
        const saveResult = await saveTurnoPDFService(pdfFile, idSave, {
          userName: usuario,
          fechaCierre: formatDateRegular(new Date().toISOString()),
        });

        if (!saveResult.success) {
          console.warn(
            "⚠️ El PDF se generó localmente pero no se pudo guardar en el servidor:",
            saveResult.error
          );
        }
      } catch (error) {
        console.warn("⚠️ Error al guardar PDF en servidor:", error);
      }
    }

    return {
      success: true,
      fileName: fileName,
      pdfUrl: pdfUrl,
      pdfFile: pdfFile,
      idSave: idSave,
    };
  } catch (error) {
    console.error("❌ Error generando PDF:", error);

    const errorDoc = new jsPDF();
    errorDoc.setFont("helvetica", "bold");
    errorDoc.setFontSize(12);
    errorDoc.text("Error al generar comprobante", 20, 30);
    errorDoc.setFontSize(9);
    errorDoc.text("No se pudo generar el comprobante del cierre de turno.", 20, 45);
    errorDoc.text("Por favor, contacte al administrador del sistema.", 20, 55);

    const errorFileName = `error_cierre_${Date.now()}.pdf`;
    errorDoc.save(errorFileName);

    throw new Error(`Error generando PDF: ${error.message}`);
  }
};
